<template>
  <div class="wrap">
    <main class="main">
      <p class="title">考试答题</p>
      <div class="line"></div>
      <div class="content">
        <dl v-for="(item, index) in subject_list" :key="index">
          <dt>{{ item.title }}</dt>
          <dd
            v-for="(option, option_index) in item.options"
            :key="option_index"
            :data-index="index"
            :data-sub_index="option_index"
            @click="changeOption"
          >
            <span :class="['option_bg', option.checked ? 'checkbox' : '']">
              {{ answer_index_dict[option_index] }}、{{ option.label }}
            </span>
          </dd>
        </dl>
      </div>
      <footer class="footer">
        <el-button @click="clickTempStorage">暂存</el-button>
        <el-button type="primary" @click="clickSubmit">提交</el-button>
      </footer>
    </main>
    <Error @emit="clickRestart" :show.sync="show_error" :errorList="errorList" />
    <Success :show.sync="show_success" />
  </div>
</template>

<script>
import { questionnare } from "@/utils/subject";
import Error from "./components/ErrorDialog";
import Success from "./components/SuccessDialog";
import { fetchExamDetail, fetchSubmitExam } from "@/api/exam";
import { ExamPassedScore } from "@/utils/enum";
import { deepClone } from "@/utils";
export default {
  name: "Exam",
  data() {
    return {
      answer_id: "",
      //考试信息剩余时间等
      examDetail: {},
      subject_list: deepClone(questionnare),
      show_error: false,
      show_success: false,
      record_now: null,
      answer_index_dict: {
        "0": "A",
        "1": "B",
        "2": "C",
        "3": "D",
        "4": "E",
        "5": "F",
        "6": "G",
        "7": "H",
        "8": "I"
      },
      index_answer_dict: {
        A: "0",
        B: "1",
        C: "2",
        D: "3",
        E: "4",
        F: "5",
        G: "6",
        H: "7",
        I: "8"
      },
      errorList: '',
    };
  },
  components: {
    Error,
    Success
  },
  watch: {
    $route(val) {
      const { id } = val.query;
      this.clearSubjectList();
      this.answer_id = id;
      if (id) {
        fetchExamDetail({
          answer_id: id
        }).then((res) => {
          const { data } = res;

          this.examDetail = data;
          this.resumeTempStorage();
          this.record_now = this.$moment();
        });
      }
    }
  },
  mounted() {
    const { id } = this.$route.query;
    this.answer_id = id;
    if (id) {
      fetchExamDetail({
        answer_id: id
      }).then((res) => {
        const { data } = res;

        this.examDetail = data;
        this.resumeTempStorage();
        this.record_now = this.$moment();
      });
    }

    window.autoFill = () => {
      const { subject_list } = this;

      subject_list.map((elem) => {
        this.setSubjectItem(elem, "AB");
      });
    };
  },
  methods: {
    clickRestart() {
      this.show_error = false;
    },
    //清除问卷选项
    clearSubjectList() {
      const { subject_list } = this;
      subject_list.map((subject) => {
        subject.options.map((elem) => {
          this.$set(elem, "checked", false);
        });
      });
    },
    // 恢复暂存的问卷
    resumeTempStorage() {
      const { examDetail, subject_list } = this;
      if (examDetail.answer && examDetail.answer.answer) {
        let submit = null;
        try {
          submit = JSON.parse(examDetail.answer.answer);
        } catch (error) {
          submit = null;
        }
        if (submit !== null) {
          for (let key in submit) {
            this.setSubjectItem(subject_list[key - 1], submit[key]);
          }
        }
      }
    },
    //设置选中题目的选项
    setSubjectItem(subject, option_str = "") {
      const { index_answer_dict } = this;
      if (option_str) {
        let list = option_str.split("");
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          let option_index_map = index_answer_dict[item];
          this.$set(subject.options[option_index_map], "checked", true);
        }
      }
    },

    changeOption(ev) {
      const { index, sub_index } = ev.currentTarget.dataset;
      const { subject_list } = this;
      const subject = subject_list[index];
      const option = subject.options[sub_index];
      //   const type = subject.type;
      //   type === "radio" && this.resetOption(subject);
      this.$set(option, "checked", !option.checked);
    },
    resetOption(subject) {
      subject.options.forEach((option) => {
        this.$set(option, "checked", false);
      });
    },
    // isSubmit true 提交 false 暂存不校验
    getExamOptions(isSubmit = true) {
      const { subject_list } = this;

      let submit = {};

      for (let i = 0; i < subject_list.length; i++) {
        let subject = subject_list[i];
        let has_checked = subject.options.some((option) => {
          return option.checked;
        });

        if (isSubmit && !has_checked) {
          this.$message({ message: `请填写 ${subject.title} 的答案！` });
          return null;
        }
        // let answer = subject.answer;
        let options = [];
        subject.options.map((option, index) => {
          if (option.checked) {
            options.push(this.answer_index_dict[index]);
          }
        });

        submit[i + 1] = options.join("");
      }

      return submit;
    },
    //点击提交
    clickSubmit() {
      const { answer_id } = this;
      let submit = this.getExamOptions(true);
      if (submit != null) {
        fetchSubmitExam({
          answer_id,
          answer: JSON.stringify(submit),
          type: 2
        }).then((res) => {
          const { data } = res;
          const { score } = data;
          if (score >= ExamPassedScore) {
            this.show_success = true;
          } else {
            let errorList = '您的第';
            for(let i  in submit){
              if(submit[i] != questionnare[i-1].answer){
                  errorList += i+','
              }
            }
            errorList = errorList.slice(0,errorList.length - 1)+'题答案有误'
            this.errorList = errorList
            this.show_error = true;
          }
        });
      }
    },
    //点击暂存
    clickTempStorage() {
      const { examDetail, record_now, answer_id } = this;
      const { now_time, end_time } = examDetail;
      let now = this.$moment().valueOf();
      // 页面打开到点击暂存按钮花费秒数
      let diffSecond = (now - record_now.valueOf()) / 1000;
      //服务器结束剩余秒数
      let serveEndSecond = end_time - now_time;
      let submit = this.getExamOptions(false);

      let leftSecond = serveEndSecond - diffSecond;
      fetchSubmitExam({
        answer_id,
        answer: JSON.stringify(submit),
        type: 1,
        second: leftSecond >= 0 ? leftSecond : 0
      }).then(() => {
        this.$message({
          type: "success",
          message: "暂存成功"
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
